import { SpotifyAuthStatePayload } from '~/pages/api/spotify/auth/types';
import { toPublicEndpoint } from '~/app/lib/getPublicEndpoint';
import { SCOPES } from '~/pages/api/spotify/auth/constants';
import { isAndroid, isIos } from '~/app/lib/device/utils';

export const resolveSpotifyAppUrl = (userAgent: string): URL | undefined => {
  // NOTE: IOS throw an alert in case app is not installed on the phone
  if (isIos(userAgent)) {
    return new URL('spotify-action://authorize');
  }

  // NOTE: In case user miss installed app on the phone
  // it will ask to install the app or even instantly opens the store
  if (isAndroid(userAgent)) {
    const url = new URL('intent://accounts.spotify.com/inapp-authorize');
    url.hash = 'Intent;scheme=https;package=com.spotify.music;end';

    return url;
  }
};

export const composeSpotifyAuthUrl = ({
  clientId,
  url,
  fallbackUrl,
}: {
  clientId: string;
  url: URL;
  fallbackUrl: string;
}) => {
  const statePayload: SpotifyAuthStatePayload = {
    // we don't need to url encode this, spotify encodes `state` params
    // before redirecting back to callback page (unlike deezer)
    pageUrl: fallbackUrl,
  };

  // encode to base64 otherwise spotify native app returns error
  const state = Buffer.from(JSON.stringify(statePayload)).toString('base64');

  url.searchParams.append('response_type', 'code');
  url.searchParams.append('client_id', clientId);
  url.searchParams.append('scope', SCOPES.join(' '));
  url.searchParams.append('state', state);
  url.searchParams.append('show_dialog', 'true');

  url.searchParams.append(
    'redirect_uri',
    toPublicEndpoint('/api/spotify/auth/callback')
  );

  return url;
};
